export type Reading = {
  configured: boolean;
  value: number | null;
  measuredAt: string | null;
  status: "DISABLED" | "GOOD" | "UNAVAILABLE";
};

export function isReading(value: unknown): value is Reading {
  if (!value || typeof value !== "object") return false;
  if (!("configured" in value) || !("status" in value) || !("value" in value) || !("measuredAt" in value)) return false;
  const item = value;
  return typeof item.configured === "boolean" &&
    (item.status === "DISABLED" || item.status === "GOOD" || item.status === "UNAVAILABLE") &&
    (item.value === null || (typeof item.value === "number" && Number.isSafeInteger(item.value) && item.value >= 0)) &&
    (item.measuredAt === null || typeof item.measuredAt === "string");
}
